import $ from 'jquery';

export default class {
	constructor() {

		this.selectors = {
			search: '.js-search-form',
			searchResult: '.js-search-result',
			searchResultItem: '.js-search-result-item'
		};

		this.defaults = {
			searchUrl: '/ajax/search/all/',
			success: 'OK',
			suggestTagOpen: '<b>',
			suggestTagClose: '</b>',
			resultTagOpen: '<span class="search__span">',
			resultTagClose: '</span>',
			itemActive: 'search__link_active'

		};

		this.$search = $(this.selectors.search);
		this.$searchResult = this.$search.find(this.selectors.searchResult);
		this.$searchResultItemTmp = this.$search.find(this.selectors.searchResultItem).eq(0).clone();
		this.$searchResultItemTmp.find('a').empty();
		this.$searchResult.empty();

		$('html').on('click', () => this.$searchResult.hide());
	}

	query(e) {

		const $results = this.$searchResult.find('.' + this.defaults.itemActive);

		if (e.keyCode === 9) {
			this.$searchResult.hide();
			return true;
		} else if (e.keyCode === 40) {

			if ($results.length === 0 || !$results.next().length) {
				this.$searchResult.find(this.selectors.searchResultItem).removeClass(this.defaults.itemActive);
				this.$searchResult.find(this.selectors.searchResultItem).eq(0).addClass(this.defaults.itemActive);
			} else {
				this.$searchResult.find(this.selectors.searchResultItem).removeClass(this.defaults.itemActive);
				$results.next().addClass(this.defaults.itemActive);
			}

			return true;

		} else if (e.keyCode === 38) {

			if ($results.length === 0 || !$results.prev().length) {
				this.$searchResult.find(this.selectors.searchResultItem).removeClass(this.defaults.itemActive);
				this.$searchResult.find(this.selectors.searchResultItem + ':last').eq(0).addClass(this.defaults.itemActive);
			} else {
				this.$searchResult.find(this.selectors.searchResultItem).removeClass(this.defaults.itemActive);
				$results.prev().addClass(this.defaults.itemActive);
			}

			return true;

		} else if (e.keyCode === 13 && $results.length) {
			this.setResultItem(e, $results.find('a'));
			return true;
		}
		const $target = $(e.target);

		$.post(this.defaults.searchUrl, {
			q: $target.val()
		}, data => this.writeResult(data), 'json');

	}

	writeResult(data) {
		const self = this;
		const result = data;
		if (result.count && result.items.length) {

			self.$searchResult.empty();

			result.items.forEach(function (item) {
				item.desc = item.desc.replace(self.defaults.suggestTagOpen, self.defaults.resultTagOpen)
				.replace(self.defaults.suggestTagClose, self.defaults.resultTagClose);
				self.$searchResult.append(self.createClone(item));
			});

			self.$searchResult.show();
			self.$searchResult.find(self.selectors.searchResultItem).each((i, item) => {
				$(item).find('a').on('click', self.setResultItem.bind(self));
			});
		}
	}

	createClone(data) {
		const clone = this.$searchResultItemTmp.clone();
		clone.find('a').attr('href', data.href);
		clone.find('a').append(data.desc);
		return clone;
	}

	setResultItem(e, target) {
		const $target = target ? target : $(e.currentTarget);
		this.$search.find('input').val($target.text());
		this.$searchResult.hide();
	}

	hideResult(e) {
		if (!$(e.target).closest(this.selectors.search)) {
			this.$searchResult.hide();
		}
	}


	render() {
		this.$search.find('input').on('keydown', e => this.query(e));
		$('body').on('click', e => this.hideResult(e));
	}
}



/** WEBPACK FOOTER **
 ** ./app/blocks/search/search.js
 **/